import React, { useEffect, useState } from "react";
import { useUser } from "../../../../hooks/useUser";
import { aunjaiBackendService } from "../../../../services/aunjai-backend.service";
import styles from "./style.module.css";

const Notification = () => {
  const { userData } = useUser();

  const [totalUnread, setTotalUnread] = useState(0);

  useEffect(() => {
    const fetchNotifications = async () => {
      if (!userData?.id) return;
      const { totalUnread } =
        await aunjaiBackendService.getLineNotificationHistories({
          borrowerId: userData?.id,
          limit: 1,
          page: 1,
        });
      setTotalUnread(totalUnread || 0);
    };

    fetchNotifications();
  }, [userData?.id]);

  const formattedNotifcationLength = totalUnread > 9 ? "9+" : totalUnread;

  return (
    <div className={styles.container}>
      {totalUnread > 0 && (
        <div className={styles.notification}>
          <p>{formattedNotifcationLength}</p>
        </div>
      )}
      <img src="/assets/img/ci/icon/notification.svg" alt="notification" />
    </div>
  );
};

export default Notification;
